/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/291' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/list`
 */
export interface StationListGetRequest {}

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/list`
 */
export type StationListGetResponse = {
  /**
   * 充电站id
   */
  stationID?: string;
  /**
   * 充电站名称
   */
  stationName?: string;
  /**
   * 设备id
   */
  deviceId?: number;
  /**
   * 设备名称
   */
  deviceName?: number;
  /**
   * 绑定时间
   */
  bindTime?: {
    /**
     * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
     */
    seconds?: number;
    /**
     * The number of nanoseconds, later along the time-line, from the seconds field.
     * This is always positive, and never exceeds 999,999,999.
     */
    nanos?: number;
  };
  /**
   * 绑定状态 true 已绑定
   */
  bindState?: boolean;
  /**
   * 绑定人
   */
  bindUserName?: string;
  /**
   * 充电桩列表
   */
  equipmentInfos?: {
    /**
     * 充电桩id
     */
    equipmentID?: string;
    /**
     * 充电桩
     */
    equipmentName?: string;
    /**
     * 设备id
     */
    deviceId?: number;
    /**
     * 设备名称
     */
    deviceName?: number;
    /**
     * 绑定时间
     */
    bindTime?: {
      /**
       * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
       */
      seconds?: number;
      /**
       * The number of nanoseconds, later along the time-line, from the seconds field.
       * This is always positive, and never exceeds 999,999,999.
       */
      nanos?: number;
    };
    /**
     * 绑定状态 true 已绑定
     */
    bindState?: boolean;
    /**
     * 充电枪列表
     */
    connectorInfos?: {
      /**
       * 充电枪id
       */
      connectorID?: string;
      /**
       * 充电枪名称
       * describe 充电设备接口名称 <= 30字符
       */
      connectorName?: string;
      /**
       * 设备id
       */
      deviceId?: number;
      /**
       * 设备名称
       */
      deviceName?: number;
      /**
       * 绑定时间
       */
      bindTime?: {
        /**
         * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
         */
        seconds?: number;
        /**
         * The number of nanoseconds, later along the time-line, from the seconds field.
         * This is always positive, and never exceeds 999,999,999.
         */
        nanos?: number;
      };
      /**
       * 绑定状态 true 已绑定
       */
      bindState?: boolean;
    }[];
  }[];
}[];

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/list`
 */
type ApiStationListGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/291',
    '',
    'http://127.0.0.1',
    '/api/station/list',
    'retdata',
    string,
    string,
    true
  >
>;

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/list`
 */
const apiStationListGetRequestConfig: ApiStationListGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/station/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiStationListGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [绑定车链设备管理↗](http://10.50.16.213:40001/project/291/interface/api/cat_2036)
 * @请求头 `GET /api/station/list`
 */
export const apiStationListGet = /*#__PURE__*/ (requestData?: StationListGetRequest, ...args: UserRequestRestArgs) => {
  return request<StationListGetResponse>(prepare(apiStationListGetRequestConfig, requestData), ...args);
};

apiStationListGet.requestConfig = apiStationListGetRequestConfig;

/* prettier-ignore-end */
